import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, Button, Link, Stack, TextField, Typography } from "@mui/material";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import { useTranslation } from "react-i18next";
import AuthPageShell from "../components/auth/AuthPageShell";
import { requestPasswordReset } from "../api/auth";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [identifier, setIdentifier] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [resetUrl, setResetUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setResetUrl("");
    setLoading(true);

    try {
      const data = await requestPasswordReset(identifier);
      setSuccess(data.message || t("authForgot.success"));
      setResetUrl(data.resetUrl || "");
    } catch (err) {
      if (err.response?.data?.code === "RATE_LIMITED") {
        setError(t("authForgot.rateLimited"));
      } else {
        setError(err.response?.data?.error || t("authForgot.error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageShell
      title={t("authForgot.title")}
      subtitle={t("authForgot.subtitle")}
    >
      <Stack component="form" spacing={2} onSubmit={handleSubmit}>
        <TextField
          label={t("authForgot.identifier")}
          value={identifier}
          onChange={(event) => setIdentifier(event.target.value)}
          autoComplete="username"
          required
          fullWidth
        />

        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        {resetUrl && (
          <Alert severity="info">
            <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>
              {t("authForgot.devResetLink")}{" "}
              <Link component={RouterLink} to={new URL(resetUrl).pathname + new URL(resetUrl).search}>
                {resetUrl}
              </Link>
            </Typography>
          </Alert>
        )}

        <Button
          type="submit"
          variant="contained"
          startIcon={<MarkEmailReadIcon />}
          disabled={loading}
          fullWidth
        >
          {loading ? t("authForgot.preparing") : t("authForgot.request")}
        </Button>

        <Link component={RouterLink} to="/login" underline="hover">
          {t("authForgot.backToLogin")}
        </Link>
      </Stack>
    </AuthPageShell>
  );
};

export default ForgotPasswordPage;
